"use client";

import { CheckIcon } from "@phosphor-icons/react/dist/ssr";
import { Checkbox as RadixCheckbox } from "radix-ui";
import type { ComponentProps, ElementRef } from "react";
import { forwardRef } from "react";
import { cn } from "@/core/shared/v2/lib/utils";

const { Root, Indicator } = RadixCheckbox;

type CheckboxSize = "default" | "sm";

type CheckboxProps = ComponentProps<typeof Root> & { size?: CheckboxSize };

const Checkbox = forwardRef<ElementRef<typeof Root>, CheckboxProps>(
  ({ className, name, size = "default", ...props }, ref) => {
    return (
      <Root
        ref={ref}
        data-slot="checkbox"
        aria-label={name}
        className={cn(
          "peer shrink-0 cursor-pointer rounded border border-primary ring-offset-background",
          size === "sm" ? "size-5" : "size-6",
          "focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
          "disabled:cursor-not-allowed disabled:opacity-50",
          "data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
          className,
        )}
        {...props}
      >
        <Indicator
          data-slot="checkbox-indicator"
          className="flex items-center justify-center text-current transition-none"
        >
          <CheckIcon className={size === "sm" ? "size-3" : "size-3.5"} weight="bold" />
        </Indicator>
      </Root>
    );
  },
);
Checkbox.displayName = "Checkbox";

export { Checkbox };
